import { memo } from "react";

type Props = {
	title: string;
	children: React.ReactNode;
};

export const FormFieldLayout = memo(({ title, children }: Props) => {
	return (
		<div className="space-y-3">
			<h5 className="font-semibold">{title}</h5>

			{children}
		</div>
	);
});
